<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="Dedication-ded">To the inspiring memory and kindness of Lloyd Alexander,</p>
<p class="Dedication-ded-last">And to the students at Mindess Elementary School in Ashland, Massachusetts, for first leading me, on March 15, 2012, to</p>
<p class="Dedication-ded"><span class="ePub-I">Emperor,</span></p>
<p class="Dedication-ded"><span class="ePub-I">Ostrich,</span></p>
<p class="Dedication-ded-last"><span class="ePub-I">and Ghoul,</span></p>
<p class="Dedication-ded">and to the thousands of children who’ve brainstormed with me in creative-writing workshops ever since. To answer the question you frequently ask me, <span class="ePub-I">Yes</span>. This really is how I write a story, and this one’s for you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e9e54ff8